<template>
  <b-container fluid></b-container>
</template>

<script lang="ts">
export default {
  name: "AppFooter"
};
</script>

<style lang="scss">
.footer {
  height: 100px;
}
</style>